import { CoherenceNav, INavLinkGroup } from "@coherence-design-system/controls";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { matchPath, useLocation, useNavigate } from "react-router";
import styles from "../styles/navBar.module.css";

const NavBar: React.FC = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [resizeTrigger, setResizeTrigger] = useState(0); // 🔧 triggers re-render on resize
  const location = useLocation(); // replaces props.location
  const navigate = useNavigate();

  const handleNavCollapsed = (value: boolean) => {
    setIsNavCollapsed(value);
  };

  useEffect(() => {
    const handleResize = () => {
      setResizeTrigger((prev) => prev + 1);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navLinkGroups: INavLinkGroup[] = [
    {
      key: "group1",
      links: [
        {
          name: isNavCollapsed ? "" : "Create or edit a menu",
          icon: "FieldNotChanged",
          key: "MenuManagement",
          ariaLabel: "Create or edit a menu",
          title: "Create or edit a menu",
          onClick: () => navigate("/menus"),
          isSelected: !!matchPath("/menus", location.pathname),
        },
        {
          name: isNavCollapsed ? "" : "Manage images",
          icon: "Photo2",
          key: "ImageManagement",
          ariaLabel: "Manage images",
          title: "Manage images",
          onClick: () => navigate("/images"),
          isSelected: !!matchPath("/images", location.pathname),
        },
        {
          name: isNavCollapsed ? "" : "Cafe Sync",
          icon: "Sync",
          key: "CafeSync",
          ariaLabel: "Cafe Sync",
          title: "Cafe Sync",
          onClick: () => navigate("/cafeSync"),
          isSelected: !!matchPath("/cafeSync", location.pathname),
        },
      ],
    },
  ];

  return (
    <CoherenceNav
      key={resizeTrigger}
      styles={{ root: classNames(styles.navBarContainer, { [styles.collapsed]: isNavCollapsed }) }}
      appName={"Chef's Menu"}
      groups={navLinkGroups}
      defaultIsNavCollapsed={true}
      isNavCollapsed={isNavCollapsed}
      onNavCollapsed={handleNavCollapsed}
      changeOpenStateOnResize={false}
    />
  );
};

export default NavBar;
